import React from 'react';
import Page from 'components/Page';
import { Button, Row, Col } from 'reactstrap';
import { MdAdd, } from 'react-icons/lib/md';
import AccessPointCreditCreate from 'components/AccessPointCreditCreate';
import DynamicTableNoEdit from 'components/DynamicTableNoEdit';
// import TablePlaque from 'components/TablePlaque';
// import DeleteModal from 'components/DeleteModal';
import { connect } from 'react-redux';
import * as loginSelectors from 'store/login/reducer';

class AccessPointCreditPage extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      show_form: false,
      show_deleting : false,
      columns: [
        {name: 'id', title: 'ID'},
        {name: 'lojista', title: 'Lojista'},
        {name: 'credito', title: 'Crédito'},
        {name: 'datahora', title: 'Data do Registro'},
        {name: 'usuario', title: 'Responsável'}
      ],
      reload : false,
      editingObj : null,
      delete_id : -1
    };
    this.addAction = this.addAction.bind(this);
    this.closed = this.closed.bind(this);
  }
  addAction(){
    this.setState({ show_form : !this.state.show_form})
  }
  closed(refresh){
    if(refresh){
      this.setState({ show_form : false, reload : !this.state.reload, editingObj : null} )
    }else{
      this.setState({ show_form : false, editingObj : null})
    }
  }

  render() {
    return (
      <Page
        title="Crédito Lojista"
        className="AccessPointCreditPage">
        <Row>
          <Col>
            <Button outline onClick={this.addAction}><MdAdd size={25} /> Adicionar</Button>
          </Col>
        </Row>
        <DynamicTableNoEdit
          user={this.props.user}
          api="admin/access-point-credit"
          columns={this.state.columns}
          dateFilter="false"
          integratedFilter="false"
          currencyColumns="false"
          showPagingState="false"
          filterState="false"
          integratePag="false"
          editingObj="false"
          reload={this.state.reload}
        />
        <AccessPointCreditCreate
          visible={this.state.show_form}
          user={this.props.user}
          editing={this.state.editingObj}
          toggle={this.closed}
        />
      </Page>
    );
  }
};

// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
  const currentUser = loginSelectors.getUser(state);
  return {
    user : currentUser
  };
}
export default connect(mapStateToProps)(AccessPointCreditPage)


// WEBPACK FOOTER //
// ./src/pages/AccessPointCredit.js